import * as z from "zod";
import { getHomeMetrics } from "./get-home-metrics";

/** The cards read through unified analytics, each the figure a custom report with that metric
 * and a "Last 30 days" filter returns. Null until the warm reaches the merchant. */
export const getHomeMetricsUnified = {
  name: "getHomeMetricsUnified" as const,
  input: z.null(),
  output: getHomeMetrics.output.nullable(),
};
